module.exports = __webpack_public_path__ + "img/bf-bg-short.7824306a.png";